





















































import { Component, Ref, Vue } from 'vue-property-decorator';
import { MessageTypeItem, MessageTypeItemImpl } from '@/store/settings/message_types/types';
import { Action } from 'vuex-class';
import {cloneDeep, isEqual} from "lodash";
import { notifyError, notifyDelete, notifyConfirm } from '@/utils/notify-helper';
import {ActionLog} from "@/store/auth/types";
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({components: {}})
export default class MessageType extends Vue {

  @Ref('validator') validator: any;

  @Action("getMessageTypeItem") actionGetItem: any;
  @Action("saveMessageTypeItem") actionSaveItem: any;
  @Action("deleteMessageTypeItem") actionDeleteItem: any;
  @Action("actionLog") actionLog: any;

  item = this.defaultItem();
  itemSaved = this.defaultItem();
  private logObject: ActionLog = {};

  defaultItem(): MessageTypeItem {
    return new MessageTypeItemImpl();
  }

  created() {
    if (this.$route.params.id) {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Message type",
        object_name: this.item.name,
        addititional_info: getTranslatedParams(this.item)
      }
      this.actionGetItem(this.$route.params.id).then((data: MessageTypeItem) => {
          this.item = Object.assign({}, this.item, data);
          this.itemSaved = cloneDeep(Object.assign({}, this.item, data));
          this.actionLog(this.logObject);
        })
        .catch((error: any) => {
          this.actionLog({...this.logObject, action_status: "failed"});
          notifyError(error);
          this.back();
        });
    }
  }

  back(): void {
    this.$router.push('/settings/message_types/');
  }

  onSaveItem(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      let valid: boolean = await this.validator.validate();
      if (valid) {
        try {
          this.logObject = {
            action_page: this.$route.meta.msgKey,
            action: this.$route.params.id ? "Editing" : "Creation",
            action_status: "success",
            object_type: "Message type",
            object_name: this.item.name,
            addititional_info: getTranslatedParams(this.item)
          }
          await this.actionSaveItem(this.item);
          await this.actionLog(this.logObject);
          this.itemSaved = this.item;
          resolve();
          this.back();
        } catch (error) {
          await this.actionLog({...this.logObject, action_status: "failed"});
          reject();
          notifyError(error);
        }
      } else {
        setTimeout(() => {
          notifyError(null, this.validator.errors)
        }, 100);
      }
    })
  }

  onDeleteItem(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      let isConfirm: boolean = await notifyDelete();
      if (isConfirm) {
        try {
          this.logObject = {
            action_page: this.$route.meta.msgKey,
            action: "Removal",
            action_status: "success",
            object_type: "Message type",
            object_name: this.item.name,
            addititional_info: getTranslatedParams({id: this.item.id})
          }
          await this.actionDeleteItem(this.item);
          await this.actionLog(this.logObject);
          this.itemSaved = this.item;
          resolve();
          this.back();
        } catch (error) {
          await this.actionLog({...this.logObject, action_status: "failed"});
          reject();
          notifyError(error);
        }
      }
    });
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    let isChange = !isEqual(this.item, this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }

};
